/*
  assets/chk-gift-back-to-top.js
  ギフトLP「ページ上部へ戻る」ボタン（<chk-gift-back-to-top>）。
  - 一定量（画面の高さの半分）スクロールしたら data-visible を付けて表示する。
  - HorizonはPC（990px以上）で .page-wrapper をスクロール枠にし、SPは document が枠になる
    （assets/scroll-container.js と同じ判定）。scroll イベントはキャプチャで受け、どちらの枠でも拾う。
  - 動きを減らす設定（prefers-reduced-motion）のときはアニメーションせずに戻る。
*/
if (!customElements.get('chk-gift-back-to-top')) {
  const SQUEEZE_QUERY = window.matchMedia('(min-width: 990px)');
  const REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getScrollContainer = () => {
    if (SQUEEZE_QUERY.matches) {
      return document.querySelector('.page-wrapper') ?? document.scrollingElement ?? document.documentElement;
    }
    return document.scrollingElement ?? document.documentElement;
  };

  class ChkGiftBackToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      };

      document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
      this.button?.addEventListener('click', () => {
        getScrollContainer().scrollTo({ top: 0, behavior: REDUCED_MOTION_QUERY.matches ? 'auto' : 'smooth' });
      });
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.onScroll, { capture: true });
    }

    update() {
      const visible = getScrollContainer().scrollTop > window.innerHeight / 2;
      this.toggleAttribute('data-visible', visible);
    }
  }

  customElements.define('chk-gift-back-to-top', ChkGiftBackToTop);
}
